module.exports = __webpack_public_path__ + "img/cow4.a404e22f.png";